import React, { useEffect, useState } from "react";
import { FaCoins } from "react-icons/fa";
import { Modal } from "../shared";
import NumberInput from "../atoms/NumberInput";
import Textarea from "../atoms/Textarea";
import { okkaliraGrantError } from "../../utils/enduserWallet";

/**
 * Molekül: son kullanıcıya Okkalira yükleme formu (#397) — yalnız ekleme.
 * API çağrısını üst bileşen yapar (onSubmit({ amount, note })).
 */
export default function OkkaliraGrantModal({ open, onClose, onSubmit, saving, userName }) {
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [touched, setTouched] = useState(false);

  useEffect(() => {
    if (open) {
      setAmount("");
      setNote("");
      setTouched(false);
    }
  }, [open]);

  const error = okkaliraGrantError(amount, note);

  const handleSubmit = () => {
    setTouched(true);
    if (error) return;
    onSubmit({ amount: Number(amount), note: note.trim() });
  };

  return (
    <Modal open={open} onClose={saving ? undefined : onClose} maxWidth="md">
      <Modal.Header title="Okkalira Yükle" subtitle={userName} onClose={saving ? undefined : onClose} />
      <Modal.Body className="space-y-4">
        <NumberInput
          label="Okkalira miktarı"
          required
          min={1}
          step={1}
          value={amount}
          onChange={setAmount}
          placeholder="örn: 50"
          suffix="OKK"
          error={touched && !!error}
          errorMessage={touched ? error || "" : ""}
          aria-label="Okkalira miktarı"
        />
        <Textarea
          label="Not"
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Neden yüklendiği (isteğe bağlı)"
          rows={3}
        />
        <p className="flex items-start gap-2 text-xs text-gray-500">
          <FaCoins className="w-3.5 h-3.5 mt-0.5 text-amber-500 shrink-0" />
          Okkalira kullanıcının bakiyesine eklenir; panelden geri düşülemez.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            className="px-4 py-2 text-sm text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 disabled:opacity-50"
          >
            İptal
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            disabled={saving || (touched && !!error)}
            className="px-4 py-2 text-sm text-white bg-main rounded-lg hover:bg-mainSecond disabled:opacity-50"
          >
            {saving ? "Yükleniyor..." : "Yükle"}
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
